import { render, staticRenderFns } from "./SimpleFileManager.vue?vue&type=template&id=0e13e81e&"
import script from "./SimpleFileManager.vue?vue&type=script&lang=js&"
export * from "./SimpleFileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports